import styled from "styled-components";

interface AppLoaderProviderProps {
  loading?: number;
}

export const AppLoaderProviderWrapper = styled.div<AppLoaderProviderProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #181818;
  backdrop-filter: blur(6px);
  user-select: none;
  z-index: 1500;
  display: ${(props) => (props.loading === 1 ? "block" : "none")};
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  opacity: 0.5;
`;

export const Sidebar = styled.div`
  width: 4.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Logo = styled.div`
  width: 100%;
  height: 6rem;
  background: #3fca89;
  color: #fafafa;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Righteous", sans-serif;
  font-size: 2.5rem;
  font-weight: 400;
  cursor: pointer;
`;

export const MenuIcons = styled.div`
  width: 100%;
  height: auto;
  list-style: none;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MenuIcon = styled.div`
  width: auto;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-top: 1rem;
  border-radius: 50%;
`;

export const SocialIcons = styled.div`
  width: 100%;
  height: auto;
  list-style: none;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 2rem;
`;

export const SocialIcon = styled.div`
  width: auto;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-top: 1rem;
  border-radius: 50%;
`;

export const Content = styled.div`
  flex: 1;
  height: 100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
      to right,
      rgba(33, 34, 37, 0.95),
      rgba(33, 34, 37, 0.95)
    ),
    url("/images/bg.jpg");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.div`
  width: 30%;
  height: 4rem;
  border-radius: 2px;
  margin-bottom: 2rem;
  margin-top: -15rem;
  background: #fafafa1c;
  background-image: linear-gradient(
    to right,
    #fafafa1c 0%,
    #ffffff1a 20%,
    #fafafa1c 40%,
    #fafafa1c 100%
  );
  background-repeat: no-repeat;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: colSkeleton;

  @keyframes colSkeleton {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }
`;

export const SubTitle = styled.div`
  width: 10%;
  height: 2rem;
  border-radius: 2px;
  margin-bottom: 2rem;
  background: #fafafa1c;
  background-image: linear-gradient(
    to right,
    #fafafa1c 0%,
    #ffffff1a 20%,
    #fafafa1c 40%,
    #fafafa1c 100%
  );
  background-repeat: no-repeat;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: colSkeleton;

  @keyframes colSkeleton {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }
`;
